export default {
    dependencies: ['$element'],
    callable(ele) {
        const toggleEle = ele.querySelector('[data-read-more-toggle]');
        const contentEle = ele.querySelector('[data-read-more-content]');
        if (toggleEle) {
            toggleEle.addEventListener('click', expandContent);
        }
        function expandContent() {
            ele.replaceWith(contentEle);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/readMoreClick.js